var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 44,
    viewBox: "0 0 22 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8002 18.6087V0.399902H0.200195V18.6087C0.200195 19.3647 0.588995 20.0775 1.2586 20.4663L10.2874 25.8879L8.149 30.9423L0.783395 31.5687L6.3778 36.4071L4.6714 43.5999L11.0002 39.7767L17.329 43.5999L15.6442 36.4071L21.2386 31.5687L13.873 30.9423L11.7346 25.8879L20.7634 20.4663C21.4114 20.0775 21.8002 19.3863 21.8002 18.6087ZM8.8402 19.9911L4.5202 17.3991V4.7199H8.8402V19.9911ZM13.1602 19.9911L17.4802 17.3991V4.7199H13.1602V19.9911Z",
    fill: "#5BDD87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.60da6629a8a3d12a65b8f94b08280db2.svg";
export { ForwardRef as ReactComponent };